import { Provider } from "@angular/core";
import { MAT_DATE_FORMATS, MatDateFormats } from "@angular/material/core";

const CUSTOM_DATE_FORMATS: MatDateFormats = {
    parse: {
      dateInput: 'DD.MM.YYYY',
      timeInput: 'HH:mm'
    },
    display: {
      dateInput: 'DD.MM.YYYY',
      monthYearLabel: 'MMM YYYY',
      dateA11yLabel: 'LL',
      monthYearA11yLabel: 'MMMM YYYY',
      timeInput: 'HH:mm',
      timeOptionLabel: 'HH:mm'
    },
  };

export const MatDateFormatProvider: Provider = { 
    provide: MAT_DATE_FORMATS, 
    useValue: CUSTOM_DATE_FORMATS 
};